import { utils } from '@atlaskit/util-service-support/constants';
import type { RequestServiceOptions } from '@atlaskit/util-service-support/types';

import type { SuggestedJiraLabelResponse } from '../types';

export const getSuggestedJiraLabels = async ({
	query = '',
	absoluteUrl,
}: {
	query?: string;
	absoluteUrl: string;
}): Promise<SuggestedJiraLabelResponse> => {
	const options: RequestServiceOptions = {
		path: 'rest/api/1.0/labels/suggest',
		queryParams: { query },
		requestInit: {
			method: 'GET',
			headers: {
				accept: 'application/json',
				'x-atlassian-capability': 'ROVO_FULL_PAGE_SEARCH',
			},
		},
	};

	return utils.requestService<SuggestedJiraLabelResponse>({ url: absoluteUrl }, options);
};
